import { z } from 'zod';
import { LocaleSchema } from '../common/enums.js';
import { PermissionSchema } from '../common/permissions.js';
import { AuthUserSchema, AuthMembershipSchema } from './login.js';
/** `GET /auth/me` — user, locale, memberships, permissions, `mustChangePin`. */
export const MeResponseSchema = z.object({
    user: AuthUserSchema,
    locale: LocaleSchema,
    memberships: z.array(AuthMembershipSchema),
    permissions: z.array(PermissionSchema),
    mustChangePin: z.boolean(),
});
//# sourceMappingURL=me.js.map